<div class="container-fluid section pt-3 pb-2 pr-0">
    <span class="header">Notifications</span>
    <div class="notify-section mt-3 mb-2 pr-2" infiniteScroll [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="50" (scrolled)="getNotifications()" [scrollWindow]="false"
        *ngIf="!loading && notifications.length">
        <div class="flex flex-column" *ngFor="let notification of notifications; let i = index">
            <div class="d-flex flex-row">
                <img class="profile-img mt-2" *ngIf="notification.mumImageURL" [src]="notification.mumImageURL">
                <img class="profile-img mt-2" *ngIf="!notification.mumImageURL"
                    src="../../../../../../assets/Images/pro-pic.png">
                <div class="d-flex flex-column ml-3 excess-content">
                    <span class="title">{{notification?.title}}</span>
                    <span class="sub-title">{{notification?.subtitle}}</span>
                    <span class="notify-time">{{notification?.date | timeago}}</span>
                </div>
            </div>
            <div class="horizontal-line my-2" *ngIf="i != notifications.length - 1"></div>
        </div>
    </div>
    <div class="row my-5" *ngIf="loading">
        <div class="spinner-border loader" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="no-data" *ngIf="!notifications.length && !loading">
        <img class="align-self-center" src="../../../../../../assets/Images/NoDocuments.png" height="50" width="80"
            alt="No Notifications">
        <span>No notifications</span>
    </div>
</div>